import React from "react";
import PropTypes from "prop-types";
import { Card } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPlus } from "@fortawesome/free-solid-svg-icons";
import FilterHeader from "views/lib/components/filter/filter-header";

class NewsFilters extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      isOpen: false,
      filters: {}
    };
  }

  render() {
    const {
      isOpen
    } = this.state;

    return (
      <Card className="w-100 mb-2 rounded-0">
        <FilterHeader
          title={
            <div>
              News
              <button
                className="btn btn-success btn-sm ml-2"
                onClick={this.props.handleCreate}
                title="Create news"
              >
                <FontAwesomeIcon icon={faPlus}/>
              </button>
            </div>
          }
          totalCount={false}
          isOpen={isOpen}
          onToggle={(status) => this.setState({ isOpen: status })}
          noExpand={true}
        />
      </Card>
    );
  }
}

NewsFilters.propTypes = {
  handleCreate: PropTypes.func.isRequired,
};
export default NewsFilters;



// WEBPACK FOOTER //
// ./src/views/pages/news/filters.js